<!-- card de rodada - telas: home e rodadas -->
<div (click)="primecapButtonClick()" [ngSwitch]="cardClass" >
  <div class="mat-card-pai" *ngSwitchCase="'rodadas-card'">
    <mat-card class="mat-card">
      <div class="thumb">
        <img [src]="cardRodada?.banner | safeUrl" class="banner"/>
      </div>
      <div class="icon-logo">
        <img [src]="cardRodada?.logo| safeUrl" class="logo"/>
      </div>
      <div class="header">
        <p class="startup">{{ cardRodada?.empresaNome }}</p>
        <setor-primecap [setorStartupTag]="setorStartupTag"></setor-primecap>
      </div>
      <hr class="divisor">
      <div class="content-info">
        <mat-card-content>
          <div class="content-info-text">
            <p class="text">{{ cardRodada?.textoCard }}</p>
          </div>
          <div class="valor">{{ cardRodada?.valorRodada  | currency }}</div>
        </mat-card-content>

        <progressbar-primecap
          [valorRodadaInvestimento]="cardRodada?.valorRodada"
          [valorCaptadoRodadaInvestimento]="cardRodada?.valorCaptado"
          [valorMinimoSucessoRodadaInvestimento]="cardRodada?.valorMinimo">
        </progressbar-primecap>

        <div class="footer">
          <div class="captado">
            <mat-card-subtitle>Captado</mat-card-subtitle>
            <p>{{ cardRodada?.valorCaptado | currency }}</p>
          </div>
          <div class="participacao">
            <div *ngIf="cardRodada?.tipoRodada == 'EQUITY';then participacao else rentabilidade"></div>
            <ng-template #participacao><mat-card-subtitle>Participação</mat-card-subtitle></ng-template>
            <ng-template #rentabilidade><mat-card-subtitle>Rentabilidade/Ano</mat-card-subtitle></ng-template>
            <p>{{ cardRodada?.participacao | multiplicarValor: 100 }}%</p>
          </div>
          <div class="investidores">
            <mat-card-subtitle>Investidores</mat-card-subtitle>
            <p>{{ cardRodada?.qtdInvestidores }}</p>
          </div>
        </div>
        <div class="button-investir">
          <ng-content></ng-content>
        </div>
      </div>
    </mat-card>
  </div>

  <!-- card para lista de startups - tela: dashboard de investidor  -->
  <div class="dashboads-card" *ngSwitchCase="'dashboads-card'">
    <mat-card>
      <div class="header-dashboad">
        <img [src]="dashboardCard.empresaLogo| safeUrl" class="dashboads-card-logo"/>
        <p class="startup">{{ dashboardCard.empresaNome }}</p>
      </div>
      <setor-primecap [setorStartupTag]="setorStartupTag" class="setor"></setor-primecap>
    </mat-card>
  </div>

  <!-- card detalhes de investimento e empresa - tela: dashboard de investidor -->
  <div class="detalhes-card" *ngSwitchCase="'detalhes-card'">
    <mat-card>
      <div class="thumb">
        <img [src]="detalhesCard?.empresaInvestida?.empresaBanner| safeUrl" class="banner"/>
      </div>
      <div class="icon-logo">
        <img [src]="detalhesCard?.empresaInvestida?.empresaLogo| safeUrl" class="logo"/>
      </div>
      <div class="header">
        <p class="startup">{{ detalhesCard?.empresaInvestida?.empresaNome }}</p>
        <setor-primecap [setorStartupTag]="detalhesCard?.setorTag"></setor-primecap>

      </div>
      <hr class="divisor">
      <div class="group-detalhes-razao-social">
        <p class="startup-razao-social" *ngIf="detalhesCard?.empresaInvestida?.razaoSocial">{{ detalhesCard?.empresaInvestida?.razaoSocial }}</p>
        <p class="startup-razao-social" *ngIf="detalhesCard?.empresaInvestida?.empresaCnpj; else mascaraCnpj">CNPJ: {{ detalhesCard?.empresaInvestida?.empresaCnpj }}</p>

        <ng-template #mascaraCnpj>
          <p class="startup-razao-social">CNPJ: 00.000.000/0000-00</p>
        </ng-template>
      </div>
      <div class="group-detalhes">
        <p>Valuation da Empresa</p>
        <div class="valuation">{{ detalhesCard?.valuation  | currency }}</div>
      </div>

      <div class="row row-group-detalhes">
        <div class="group-detalhes">
          <p>Equity</p>
          <div class="valuation">{{ detalhesCard?.empresaInvestida?.percentualParticipacaoEmpresa | number: '1.5-5' }}%</div>
        </div>

        <div class="group-detalhes">
          <p>Equity Valuation</p>
          <div class="valuation">{{ detalhesCard?.empresaInvestida?.valorAtualEquity | currency }}</div>
        </div>
      </div>

      <card-lista-investimento [listaInvestimento]="detalhesCard?.listaInvestimento"></card-lista-investimento>

      <div class="group-detalhes-contato">
        <p>Contato</p>
        <div class="contato">
          <a [href]="detalhesCard?.empresaInvestida?.empresaFacebook | safeUrl" target="_blank" rel="noopener noreferrer">
            <icons-primecap name="facebook-logo">
            </icons-primecap>
          </a>
          <a [href]="detalhesCard?.empresaInvestida?.empresaInstagram | safeUrl" target="_blank" rel="noopener noreferrer">
            <icons-primecap name="instagram-logo">
            </icons-primecap>
          </a>
          <a [href]="detalhesCard?.empresaInvestida?.empresaLinkedin | safeUrl" target="_blank" rel="noopener noreferrer">
            <icons-primecap name="linkedin-logo">
            </icons-primecap>
          </a>
          <a [href]="detalhesCard?.empresaInvestida?.empresaSite | safeUrl" target="_blank" rel="noopener noreferrer">
            <icons-primecap  name="site">
            </icons-primecap>
          </a>
          <a href="mailto: {{ detalhesCard?.empresaInvestida?.empresaEmail }}" target="_blank" rel="noopener noreferrer">
            <icons-primecap name="email">
            </icons-primecap>
          </a>
        </div>

        <div class="contato">
          <icons-primecap size="small" name="phone">
          </icons-primecap>
          <p class="contato-text">{{ detalhesCard?.empresaInvestida?.empresaTelefone }}</p>
        </div>
      </div>
      <hr class="divisor" *ngIf="detalhesCard?.ultimaLamina">
      <div class="group-detalhes-relatorio" *ngIf="detalhesCard?.ultimaLamina">
        <mat-card>
          <div class="relatorio">
            <div class="group-icons">
              <a [href]="detalhesCard?.ultimaLamina | safeUrl" target="_blank">
                <icons-primecap name="pdf">
                </icons-primecap>
                <p>Último Relatório</p>
              </a>
            </div>
          </div>
        </mat-card>
      </div>
    </mat-card>
  </div>

  <!-- card para contato de fundo de investimento -->
  <div class="contato-card" *ngSwitchCase="'contato-card'">
    <mat-card>
      <div class="header">
        <p class="startup">{{ cardContato?.nome }}</p>
      </div>

      <div class="group-contato">
        <div class="contato" *ngIf="cardContato?.email">
          <icons-primecap size="small" name="email">
          </icons-primecap>
          <a href="mailto: {{ cardContato?.email }}" target="_blank" rel="noopener noreferrer">
            <p class="contato-text">{{ cardContato?.email }}</p>
          </a>
        </div>

        <div class="contato">
          <icons-primecap size="small" name="phone">
          </icons-primecap>
          <p class="contato-text">{{ cardContato?.telefone }}</p>
        </div>
      </div>

      <div class="group-redes-socias" *ngIf="cardContato?.facebook || cardContato?.instagram || cardContato?.linkedin || cardContato?.site">
        <p >
          Redes Sociais
        </p>
        <div class="contato">
          <a *ngIf="cardContato?.facebook" [href]="cardContato?.facebook | safeUrl" target="_blank" rel="noopener noreferrer">
            <icons-primecap name="facebook-logo">
            </icons-primecap>
          </a>
          <a *ngIf="cardContato?.instagram" [href]="cardContato?.instagram | safeUrl" target="_blank" rel="noopener noreferrer">
            <icons-primecap name="instagram-logo">
            </icons-primecap>
          </a>
          <a *ngIf="cardContato?.linkedin" [href]="cardContato?.linkedin | safeUrl" target="_blank" rel="noopener noreferrer">
            <icons-primecap name="linkedin-logo">
            </icons-primecap>
          </a>
          <a *ngIf="cardContato?.site" [href]="cardContato?.site | safeUrl" target="_blank" rel="noopener noreferrer">
            <icons-primecap  name="site">
            </icons-primecap>
          </a>
        </div>
      </div>

      <div class="group-contato-observacao" *ngIf="cardContato?.observacao">
        <p>Observação</p>
        <div>{{ cardContato?.observacao }}</div>
      </div>
    </mat-card>
  </div>

  <div class="alert" *ngSwitchCase="">
    <p>Verifique o nome da class <br>
      E passe no atributo cardClass a a classe que deseja utilizar</p>
  </div>
</div>
